module.exports = __webpack_public_path__ + "static/media/result_economics.8c1ea02a.png";